import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _ClosePhysical, _CreateTaking, _ExportPhysical, _PhysicalTaking, _RegisterPhysical } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { SelectStoreEditor } from "../../../contract/etapa-contrato/contrac/ublinvoice/SelectStore.editor";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { InputDate } from "../../../theme/Input/InputDate";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { EditorFixedAssetItem } from "../../../contract/etapa-contrato/contrac/ublinvoice/FixedAssetItem/EditorFixedAssetItem";
import { PhysicalTakingForActionSelect } from "./PhysicalTakingForActionSelect";
import { PhysicalTakingConstants } from "../../../../core/services/dataBean/talentoHumano/PhysicalTakingConstants";
import { PhysicalTakingConstantsSelect } from "./PhysicalTakingConstantsSelect";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { PhysicalTakingItemCatalog } from "./PhysicalTakingItemCatalog/PhysicalTakingItemCatalog";
import { AccountEditor } from "../../../editor/AccountEditor";
import { TypeConstantsForAction } from "./PhysicalTakingItemCatalog/TypeConstantsForAction";
import { SelectProductEditor } from "../../../Factoty&Production/ManufacturingStandars/Components/SelectProductEditor";
import { TakingInventoryCatalog } from "./TakingInventoryCatalog/TakingInventoryCatalog";




export const PhysicalTaking = () => {

    const PhysicalTaking = useDataBean(_PhysicalTaking);
    const single = Singleton.getInstance();
    const createTaking = useDataBean(_CreateTaking);
    const register = useDataBean(_RegisterPhysical)
    const generate = useDataBean(_ExportPhysical)
    const close = useDataBean(_ClosePhysical)
    const [lista, setLista] = useState<any>([]);
    const [formatodos, setFormatodos] = useState<any>([]);
    const [year, setyear] = useState<any>(_single.getCurrenYear())
    const [modalclose, setModalclose] = useState<any>({ tabIndex: -1, view: false, btnClose: true, format: 'modal-lg' });
    const [modalcreate, setModalcreate] = useState<any>({ tabIndex: -1, view: false, btnClose: true, format: 'modal-lg' });
    const [modalregistrarbyproduct, setModalregistrarbyproduct] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalregistrar, setModalregistrar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalgenerar, setModalgenerar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalvertabla, setModalvertabla] = useState<any>({ tabIndex: -1, view: false, btnClose: true, format: 'modal-lg' });
    const [modalvertablados, setModalvertablados] = useState<any>({ tabIndex: -1, view: false, btnClose: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [year])

    const getLista = () => {

        PhysicalTaking.instance.getPhysicalTakingCatalog(year).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const createPhysicalTakingItem = () => {

        createTaking.instance.createPhysicalTakingItem(PhysicalTaking.bean.IDPhysicalTaking).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Creado con Exito');
                    setModalcreate({ ...modalcreate, "view": false });
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }



    const closePhysicalTaking = () => {

        close.instance.closePhysicalTaking(PhysicalTaking.bean.IDPhysicalTaking).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Toma Física Cerrada con Exito');
                    setModalclose({ ...modalclose, "view": false });
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const registerPhysicalTakingProduct = () => {

        register.instance.registerPhysicalTakingProduct(PhysicalTaking.bean.IDPhysicalTaking, register.bean.IDProduct, register.bean.IDProduct, register.bean.Quantity, register.bean.Observations).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Registrado con Exito');
                    setModalregistrarbyproduct({ ...modalregistrarbyproduct, "view": false });
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const registerPhysicalTakingFixedAssetItem = () => {

        register.instance.registerPhysicalTakingFixedAssetItem(PhysicalTaking.bean.IDPhysicalTaking, register.bean.IDItem, register.bean.TicketCode, register.bean.Observations, register.bean.State).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Registrado con Exito');
                    setModalregistrar({ ...modalregistrar, "view": false });
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }




    const exportPhysicalTaking = () => {

        generate.instance.exportPhysicalTaking(PhysicalTaking.bean.IDPhysicalTaking, generate.bean.State, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Generado con Exito');
                    setFormatodos(resp);
                    //  setModalr({ ...modalregistrar, "view": false });
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const create = () => {
        PhysicalTaking.setBean({
            // IDAccount: _single.getAccountID(),
            Since: _single.getCurrenDate()
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        PhysicalTaking.deleteItemVoid(PhysicalTaking.bean.IDPhysicalTaking).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }

    const head = [
        { title: 'ID', property: 'IDPhysicalTaking', visible: true },
        { title: 'Almacén/Bodega', property: 'StoreName', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'Fecha de Corte de Inventario', property: 'InitialTakingLeftDate', visible: true },
        { title: 'Fecha de inicio de toma física', property: 'TakingDateFrom', visible: true },
        { title: 'Fecha finalización de toma física', property: 'TakingDateUpto', visible: true },
        { title: 'Observaciones', property: 'Observations', visible: true },
        { title: 'Incluir Controlados', property: 'ApplyToControlled', visible: true },
        { title: 'Responsable', property: 'EmployeeName', visible: true },
        { title: 'Fecha Creación', property: 'Since', visible: true },
    ]


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            {
                titulo: 'Lanzar Toma Física',
                icono: 'ri-edit-2-line',
                visible: single.canEdit(),
                evento: () => { setModalcreate({ ...modalcreate, "view": true }) }
            },
            {
                titulo: 'Registrar Item de Toma Física',
                icono: 'ri-edit-2-line',
                visible: single.canEdit() && PhysicalTaking.bean?.Type === 5,
                evento: () => { setModalregistrar({ ...modalregistrar, "view": true }) }
            },
            {
                titulo: 'Registrar Item de Toma Física por Producto',
                icono: 'ri-edit-2-line',
                visible: single.canEdit() && PhysicalTaking.bean?.Type === 6,
                evento: () => { setModalregistrarbyproduct({ ...modalregistrarbyproduct, "view": true }) }
            },
            {
                titulo: 'Generar Reporte /Conciliación de Activos en Inventario en Excel',
                icono: 'ri-edit-2-line',
                visible: single.canEdit(),
                evento: () => { setModalgenerar({ ...modalgenerar, "view": true }); setFormatodos(null) }
            },
            {
                titulo: 'Consultar Registro de Toma Física de Activos Fijos',
                icono: 'ri-edit-2-line',
                visible: single.canEdit(),
                evento: () => { setModalvertabla({ ...modalvertabla, "view": true }) }
            },
            {
                titulo: 'Consultar Registro de Toma Física de Inventario',
                icono: 'ri-edit-2-line',
                visible: single.canEdit(),
                evento: () => { setModalvertablados({ ...modalvertablados, "view": true }) }
            },
            {
                titulo: 'Cerrar Toma Física',
                icono: 'ri-edit-2-line',
                visible: single.canEdit(),
                evento: () => { setModalclose({ ...modalclose, "view": true }) }
            },
            {
                titulo: 'Editar',
                icono: 'ri-edit-2-line',
                visible: single.canEdit() && PhysicalTaking.bean?.IDPhysicalTaking,
                evento: () => { setModal({ ...modal, "name": `Editar ${PhysicalTaking.bean.Name}`, "view": true }) }
            },
            {
                titulo: 'Eliminar',
                icono: 'ri-delete-bin-line',
                visible: single.canDelete() && PhysicalTaking.bean?.IDPhysicalTaking,
                evento: () => { setModalC({ ...modalC, "view": true }) }
            }
        ];
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const validarCampos = (): boolean => {
        const { Type, IDAccount, TakingDateFrom, TakingDateUpto } = PhysicalTaking.bean || {};

        if (!Type) {
            toast.error('Debe seleccionar un Tipo');
            return false;
        }

        if (!IDAccount) {
            toast.error('Debe seleccionar un Responsable');
            return false;
        }

        if (!TakingDateFrom) {
            toast.error('Debe ingresar la Fecha de inicio de toma física');
            return false;
        }

        if (!TakingDateUpto) {
            toast.error('Debe ingresar la Fecha finalización de toma física');
            return false;
        }

        return true;
    };
    const editaItem = () => {
        if (!validarCampos()) return;
        //console.log(entailment.bean);
        PhysicalTaking.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }


    return (
        <BasicPage titulo="Toma Física y Validación de Inventarios">
            <div className="row">
                <div className="col-md-6">
                    <YearSelector value={year} onChange={(e) => { setyear(e) }} />
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-folder-add-line" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={PhysicalTaking.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <SelectStoreEditor label='Almacén/Bodega' idSelector={PhysicalTaking.bean.IDStore} onChange={(e: any) => { PhysicalTaking.setBean({ ...PhysicalTaking.bean, "IDStore": e.IDStore }) }} />
                            </div>
                            <div className="col-md-6">
                                <TypeConstantsForAction idSelector={PhysicalTaking.bean.Type} onChange={(e) => { PhysicalTaking.setBean({ ...PhysicalTaking.bean, 'Type': e }) }} />
                            </div>
                            <div className="col-md-6">
                                <AccountEditor idAccount={PhysicalTaking.bean.IDAccount} onChange={(e) => { PhysicalTaking.setBean({ ...PhysicalTaking.bean, IDAccount: e.IDAccount }) }} label="Responsable" />
                            </div>
                            <div className="col-md-6">
                                <InputDate name="TakingDateFrom" label="Fecha de inicio de toma física" value={PhysicalTaking.bean.TakingDateFrom} setDate={(e: any) => { PhysicalTaking.setBean({ ...PhysicalTaking.bean, "TakingDateFrom": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <InputDate name="TakingDateUpto" label="Fecha finalización de toma física" value={PhysicalTaking.bean.TakingDateUpto} setDate={(e: any) => { PhysicalTaking.setBean({ ...PhysicalTaking.bean, "TakingDateUpto": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Incluir Controlados" estado={PhysicalTaking.bean.ApplyToControlled} eventChange={(e: any) => { PhysicalTaking.setBean({ ...PhysicalTaking.bean, "ApplyToControlled": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-12">
                                <label>Observaciones</label>
                                <textarea name="Observations" className="form-control" value={PhysicalTaking.bean.Observations} onChange={PhysicalTaking.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalcreate} updateModal={setModalcreate}>
                        <div className="row">
                            <div className="col-md-6">
                                <BasicButton icon="ri-send-plane-fill" clase="primary" eventClick={createPhysicalTakingItem}>Lanzar Toma Física</BasicButton>
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalclose} updateModal={setModalclose}>
                        <div className="row">
                            <div className="col-md-6">
                                <BasicButton icon="ri-send-plane-fill" clase="primary" eventClick={closePhysicalTaking}>Cerrar Toma Física</BasicButton>
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalregistrar} updateModal={setModalregistrar} eventModal={registerPhysicalTakingFixedAssetItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <EditorFixedAssetItem idSelector={register.bean.IDItem} label="Item de Activo fijo" onChange={(e) => { register.setBean({ ...register.bean, 'IDItem': e.IDItem, IDItemName: e.Name }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Placa</label>
                                <input type='text' name="TicketCode" className="form-control" value={register.bean.TicketCode} onChange={register.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <PhysicalTakingForActionSelect idSelector={register.bean.State} onChange={(e) => { register.setBean({ ...register.bean, 'State': e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Observaciones</label>
                                <textarea name="Observations" className="form-control" value={register.bean.Observations} onChange={register.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalregistrarbyproduct} updateModal={setModalregistrarbyproduct} eventModal={registerPhysicalTakingProduct}>
                        <div className="row">
                            <div className="col-md-12">
                                <SelectProductEditor value={register.bean.IDProduct} onChange={(e) => { register.setBean({ ...register.bean, "IDProduct": e.IDProduct }) }} label="Producto" />
                            </div>
                            <div className="col-md--12">
                                <label>Cantidad</label>
                                <input type='text' name="Quantity" className="form-control" value={register.bean.Quantity} onChange={register.handleChange} />
                            </div>
                            <div className="col-md-12">
                                <label>Observaciones</label>
                                <textarea name="Observations" className="form-control" value={register.bean.Observations} onChange={register.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalgenerar} updateModal={setModalgenerar} >
                        <div className="row">
                            <div className="col-md-12">
                                <PhysicalTakingConstantsSelect idSelector={generate.bean.State} onChange={(e) => { generate.setBean({ ...generate.bean, 'State': e }) }} />
                            </div>

                            <div className="row">
                                <div className="col-md-12 mt-4">

                                    <BasicButton icon="ri-folder-add-line" eventClick={exportPhysicalTaking}>Generar reporte</BasicButton>
                                </div>
                            </div>

                            <div className="col-md-12">
                                {/* <PrintJson json={formatodos} /> */}
                                {formatodos?.URLLink && (
                                    // <PrintJson json={formato.DataBeanProperties.URLLink} />
                                    <div className="row">
                                        <div className="col-md-12 mt-3">
                                            <label>Descarga en el Siguiente Link:*</label>
                                        </div>

                                        <div className="col-md-6 mt-3">
                                            <a href={formatodos.URLLink} target="_blank" rel="noopener noreferrer">
                                                <strong>{formatodos.Filename}</strong>
                                            </a>
                                        </div>
                                    </div>
                                    //aqui
                                )}
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalvertabla} updateModal={setModalvertabla} >
                        <div className="row">
                            <PhysicalTakingItemCatalog idPhysicalTaking={PhysicalTaking.bean.IDPhysicalTaking} />
                        </div>
                    </Modal>
                    <Modal modal={modalvertablados} updateModal={setModalvertablados} >
                        <div className="row">
                            <TakingInventoryCatalog idPhysicalTaking={PhysicalTaking.bean.IDPhysicalTaking} />
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {PhysicalTaking.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}